/* Core & libraries */
import * as React from "react";
import { useTheme } from "react-jss";

/* Helpers, constants, custom methods, internal libraries */
import { useUserContext } from "../../contexts/userContext";

/* Components */
import SettingsTabbedNav from "../../components/settingsTabbedNav";
import { AIRLINES } from "constants/appConstants";
import { ReactComponent as AlertIcon } from "../../resources/images/alert-circle-outlined.svg";

/* Styles */
import styles from "./styles.js"
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {defineMessages, FormattedMessage, useIntl} from "react-intl";
import Container from "react-bootstrap/Container";


const Settings = () => {
  const theme = useTheme();
  const classes = styles({ theme });
  const userContext = useUserContext();

  const companyMigratedChoice =
    userContext?.userInfo?.providerInfo?.providerCode === AIRLINES.CHOICE &&
    userContext?.forceUpdateCompanyInfo;

  return (
    <div className={classes.settings}>
      {companyMigratedChoice && (
        <div className={classes.bannerWrapper}>
          <AlertIcon />
          <div>
            <h6>
              <FormattedMessage id="settings.migratedChoiceBanner.title" />
            </h6>
            <p>
              <FormattedMessage id="settings.migratedChoiceBanner.description" />
            </p>
          </div>
        </div>
      )}
      <Container className={classes.container}>
        <Row>
          <Col xs={12} className="gx-0">
            <h1 className={classes.title}>
              <FormattedMessage id="settings.title"/>
            </h1>
            <p className={classes.subtitle}>
              <FormattedMessage id="settings.subtitle"/>
            </p>
          </Col>
        </Row>
      </Container>
      <SettingsTabbedNav companyMigratedChoice={companyMigratedChoice} />
    </div>
  )
}

export default Settings;
